var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71D1DF",
    d: "M24.498 10.171l-4.7 2.752-2.256 2.255-2.637 8.064c-.053.167-.147.317-.274.438-.127.12-.283.206-.452.25h-.268c-.272-.002-.534-.112-.726-.306l-5.12-5.083-6.23 6.23c-.221.165-.494.246-.77.226-.275-.02-.534-.138-.73-.333-.194-.195-.313-.454-.332-.73-.02-.275.06-.548.226-.768l6.23-6.23-5.121-5.121c-.117-.135-.201-.295-.248-.467-.046-.172-.053-.352-.02-.527.044-.17.13-.325.25-.452s.271-.221.438-.274l8.064-2.637 2.255-2.255L14.829.502c.078-.138.189-.255.322-.341.133-.087.284-.14.442-.156.154-.015.31.004.455.057.146.053.278.138.386.249l8.255 8.255c.11.108.196.24.249.386.053.145.072.3.057.455-.016.158-.07.31-.156.442-.086.133-.203.244-.341.322z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinned);
export default __webpack_public_path__ + "static/media/pinned.da69eb456a171ac57771ec3247d58434.svg";
export { ForwardRef as ReactComponent };